import { Box, Typography } from '@mui/material'
import tabLogo from '@/assets/svgs/tab-logo.svg'
import SVG from 'react-inlinesvg'
import InfoSliderView from './InfoSliderView'

const AuthDialogLeftView = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: { xs: 3, sm: 4, md: 5 },
        position: 'relative',
      }}
    >
      {/* Logo */}
      <Box mb={{ xs: 4, md: 6 }}>
        <SVG src={tabLogo} width={40} height={40} style={{ color: 'white' }} />
      </Box>

      {/* Hero Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: 0,
        }}
      >
        <Box mb={{ xs: 4, md: 6 }}>
          <Typography
            sx={{
              fontSize: { xs: '24px', sm: '28px', md: '40px' },
              fontWeight: 800,
              lineHeight: 1.15,
              letterSpacing: '-0.02em',
              color: 'white',
              mb: 3,
            }}
          >
            Design Stunning Patterns in Minutes
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '15px', md: '18px' },
              lineHeight: 1.7,
              fontWeight: 500,
              color: 'rgba(255, 255, 255, 0.95)',
              letterSpacing: '-0.01em',
            }}
          >
            Trusted by 10,000+ designers worldwide. Create beautiful patterns, quilts, collections,
            and galleries—all in your browser.
          </Typography>
        </Box>

        {/* Slider */}
        <Box sx={{ minHeight: 0 }}>
          <InfoSliderView />
        </Box>
      </Box>

      {/* Decorative Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: { xs: '200px', md: '300px' },
          height: { xs: '200px', md: '300px' },
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          transform: 'translate(30%, -30%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: { xs: '150px', md: '250px' },
          height: { xs: '150px', md: '250px' },
          background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)',
          borderRadius: '50%',
          transform: 'translate(-30%, 30%)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  )
}

export default AuthDialogLeftView
